module.exports = __webpack_public_path__ + "static/media/76.44e31ddf.png";